import { createContext, useContext } from "react";

import type { SearchUsersFn } from "../../../api/user/createUserSearch.js";

type OfficerLookupContextType = {
  /**
   * Override the officer search function. When provided (e.g. in Storybook),
   * the component will call this instead of making a real API request.
   */
  searchUsers?: SearchUsersFn;
};

export const OfficerLookupContext = createContext<OfficerLookupContextType>({});

export function useOfficerLookupContext(): OfficerLookupContextType {
  return useContext(OfficerLookupContext);
}
